import { getMediaApi } from '@/core/api/generatedApiClient';
import { rethrowHandledApiError } from '@/core/api/rethrowHandledApiError';

/** Описывает ошибку проверки изображения перед загрузкой */
export class ImageValidationError extends Error { }

/** Загружает изображение и возвращает его URL */
export const uploadImage = async (file: File): Promise<string> => {
    if (!file.type.startsWith('image/')) {
        throw new ImageValidationError('Файл должен быть изображением');
    }

    if (file.size > 25_000_000) {
        throw new ImageValidationError('Изображение слишком большое (макс. 25 МБ)');
    }

    try {
        const response = await getMediaApi()
            .apiV1MediaUploadImagePost(
                {
                    file,
                    apiVersion: '1.0'
                },
                { timeout: 30000 },
            );

        if (!response.data) throw new Error('Сервер не вернул URL изображения');
        return response.data;
    } catch (error: unknown) {
        return rethrowHandledApiError(error);
    }
};
